import Vue from "vue";
import Vuex from "vuex";
import cfStoreFunction from "@alliedcrowds/capital-finder-vuex";
import createPersistedState from "vuex-persistedstate";
import chartData from "./assets/chartData.js"

Vue.use(Vuex);

const cfStore = cfStoreFunction({
  apiUrl: process.env.API_URL,
  apiKey: process.env.API_KEY,
  resultsPerPage: 12,
  maxResults: 10000
});

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    cfStore: cfStore
  },
  state: {
    selectedDataSectors: [],
    selectedDataProviderTypes: [],
    selectedDataCapitalTypes: [],
    data: [],
    loadingResults: false
  },
  getters: {
    loadingResults: (state)=>state.loadingResults,

    selectedDataSectors: (state)=>state.selectedDataSectors,
    selectedDataProviderTypes: (state)=>state.selectedDataProviderTypes,
    selectedDataCapitalTypes: (state)=>state.selectedDataCapitalTypes,

    dataSectorSelected: (state) => value => state.selectedDataSectors.map(selection=>selection.name).includes(value.name),
    dataProviderTypeSelected: (state) => value => state.selectedDataProviderTypes.map(selection=>selection.name).includes(value.name),
    dataCapitalTypeSelected: (state) => value => state.selectedDataCapitalTypes.map(selection=>selection.name).includes(value.name),
    getFilterdChartData(state, getters){
      var providerTypeNames = state.selectedDataProviderTypes.map(selection=>selection.name)
      var sectorNames = state.selectedDataSectors.map(selection=>selection.name)
      var capitalTypeNames = state.selectedDataCapitalTypes.map(selection=>selection.name)
      return state.data.filter(item => {
        return getters.devCountries.some(country=>country.name == item[0])
      }).filter(item => {
        if (providerTypeNames.length > 0) {
          return providerTypeNames.includes(item[1])
        } else {
          return true
        }
      }).filter(item => {
        if (sectorNames.length > 0) {
          return sectorNames.includes(item[2])
        } else {
          return true
        }
      }).filter(item => {
        if (capitalTypeNames.length > 0) {
          return capitalTypeNames.includes(item[3])
        } else {
          return true
        }
      }).reduce(function(acc, cur) {
        var index = acc.map(item=>item.country).indexOf(cur[0])
        if (index!=-1){
          acc[index].val = acc[index].val + cur[5]
        } else {
          acc.push({
            country: cur[0],
            val: cur[5],
            color: '#3BC5CF'
          })
        }
        return acc;
      }, []).map(item=>{
        item.val = Math.ceil(item.val);
        return item;
      })
    }
  },
  mutations: {
    setLoadingResults(state, data) {
      state.loadingResults = data
    },
    setSelectedDataSectors(state, data) {
      var index = state.selectedDataSectors
        .map(selection=>selection.name).indexOf(data.name)
      if (index!=-1) {
          state.selectedDataSectors.splice(index, 1 );
      } else {
        state.selectedDataSectors = [...state.selectedDataSectors, data]
      }
    },
    setSelectedDataProviderTypes(state, data) {
      var index = state.selectedDataProviderTypes
        .map(selection=>selection.name).indexOf(data.name)
      if (index!=-1) {
          state.selectedDataProviderTypes.splice(index, 1 );
      } else {
        state.selectedDataProviderTypes = [...state.selectedDataProviderTypes, data]
      }
    },
    setSelectedDataCapitalTypes(state, data) {
      var index = state.selectedDataCapitalTypes
        .map(selection=>selection.name).indexOf(data.name)
      if (index!=-1) {
          state.selectedDataCapitalTypes.splice(index, 1 );
      } else {
        state.selectedDataCapitalTypes = [...state.selectedDataCapitalTypes, data]
      }
    },
    setData(state, data) {
      state.data = data
    }
  },
  actions: {
    getChartData(context){
      var data = getChartData()
      context.commit('setData', data)
    }
  }
});

function getChartData(){
  return chartData;
}

function getGraphData(){

}


export default store;



// WEBPACK FOOTER //
// ./src/store.js